// extracted by mini-css-extract-plugin
export default {"ace-c-emergency-lawyer-panel":"emergency-lawyers-panel---30c61efd"};